import { useEffect, useRef } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import NewsletterPopup from "@/components/NewsletterPopup";
import CartDrawer from "@/components/CartDrawer";
import { useCompare } from "@/context/CompareContext";
import { Scales, X, WhatsappLogo } from "@phosphor-icons/react";
import { SITE } from "@/data/site";

function CompareBar() {
  const { items, clear, count } = useCompare();
  if (count < 1) return null;
  return (
    <div className="fixed bottom-5 left-5 z-[55] hidden sm:flex items-center gap-3 rounded-full glass px-4 py-2.5 shadow-soft-lg" data-testid="compare-bar">
      <Scales size={20} className="text-primary" />
      <span className="text-sm font-semibold">{count} bike{count > 1 ? "s" : ""} to compare</span>
      <Link to="/compare" className="btn-primary !px-4 !py-1.5 text-xs">Compare</Link>
      <button onClick={clear} aria-label="Clear compare"><X size={16} /></button>
    </div>
  );
}

function MobileWhatsAppCTA() {
  return (
    <a
      href={SITE.whatsappHref}
      target="_blank" rel="noreferrer"
      className="btn-primary fixed bottom-5 left-5 z-[55] !px-5 !py-3 text-sm shadow-glow sm:hidden"
      data-testid="mobile-whatsapp-cta"
    >
      <WhatsappLogo size={18} weight="fill" /> WhatsApp Us
    </a>
  );
}

export default function Layout() {
  const location = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <FloatingActions />
      <CompareBar />
      <MobileWhatsAppCTA />
      <NewsletterPopup />
    </div>
  );
}
